<template>
    <div class="container">
        <div class="action-bar">
            <el-button type="primary" size="mini" @click="onSave" :loading="loading">保存</el-button>
            <div class="fileWrap">
                <el-button type="warning" size="mini" :loading="loading">
                    {{ loading ? '识别中' : '上传' }}
                </el-button>
                <input 
                    ref="inputRef" 
                    type="file" 
                    accept=".pdf,.jpg,.jpeg,.png" 
                    @change="upload"
                    :disabled="loading"
                >
            </div>
            <el-tooltip content="查看发票样板，用于参考所需字段位置" placement="top">
                <el-button type="success" size="mini" @click="showTemplate">查看样板</el-button>
            </el-tooltip>
            <el-button size="mini" @click="back" :disabled="loading">返回</el-button>
        </div>
        
        <!-- 文件类型提示 -->
        <div class="file-type-hint">
            支持的文件格式：<span class="supported-types">PDF、JPG、PNG</span>，请确保上传清晰的发票图片以获得最佳识别效果
        </div>
        
        <!-- 识别状态提示 -->
        <div v-if="showRecognitionStatus" :class="['recognition-status', recognitionStatusType]">
            <i :class="recognitionStatusIcon"></i> {{ recognitionStatusMessage }}
        </div>
        
        <!-- 样板弹窗 -->
        <el-dialog
            title="发票样板"
            :visible.sync="templateDialogVisible"
            width="80%"
            :before-close="handleCloseTemplateDialog">
            <div class="template-container">
                <!-- <div class="template-header">
                    <h2>非税收入统一票据</h2>
                </div>
                <div class="template-content">
                    <div class="template-info">
                        <p><strong>缴款码：</strong> 123456789012345</p>
                        <div class="template-row">
                            <p><strong>执收单位编码：</strong> 12345678</p>
                            <p><strong>票据代码：</strong> 123456789</p>
                            <p><strong>校验码：</strong> 1234567890</p>
                        </div>
                        <div class="template-row">
                            <p><strong>执收单位名称：</strong> XX市财政局</p>
                            <p><strong>票据号码：</strong> 12345678</p>
                            <p><strong>填制日期：</strong> 2023-01-01</p>
                        </div>
                    </div>
                    <div class="template-table">
                        <table>
                            <tr>
                                <td rowspan="3">付款人</td>
                                <td>全称</td>
                                <td>XX有限公司</td>
                                <td rowspan="3">收款人</td>
                                <td>全称</td>
                                <td>XX市财政局</td>
                            </tr>
                            <tr>
                                <td>账号</td>
                                <td>6222 **** **** 1234</td>
                                <td>账号</td>
                                <td>6222 **** **** 5678</td>
                            </tr>
                            <tr>
                                <td>开户银行</td>
                                <td>中国银行</td>
                                <td>开户银行</td>
                                <td>中国工商银行</td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <div style="display: flex;">
                                        <span style="margin-right: 50px"><strong>币种：</strong> 人民币</span>
                                        <span><strong>金额（大写）：</strong> 壹仟元整</span>
                                    </div>
                                </td>
                                <td colspan="2"><strong>（小写）：</strong> ¥1000.00</td>
                            </tr>
                            <tr>
                                <td>项目编码</td>
                                <td>收入项目名称</td>
                                <td>单位</td>
                                <td>数量</td>
                                <td>收缴标准</td>
                                <td>金额</td>
                            </tr>
                            <tr>
                                <td>101001</td>
                                <td>行政事业性收费</td>
                                <td>元</td>
                                <td>1</td>
                                <td>1000.00</td>
                                <td>1000.00</td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <div style="display: flex; justify-content: space-between;">
                                        <span><strong>执收单位盖章：</strong></span>
                                        <span><strong>经办人盖章：</strong> 张三</span>
                                    </div>
                                </td>
                                <td colspan="3" style="text-align: left;"><strong>备注：</strong> 无</td>
                            </tr>
                        </table>
                    </div>
                </div> -->
                <img src="../../assets/images/invoice.png" alt="发票图片" style="width: 100%;">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="templateDialogVisible = false">关闭</el-button>
                <!-- <el-button type="primary" @click="downloadTemplateFile">下载样板</el-button> -->
            </span>
        </el-dialog>
        <div class="tableWrap">
            <table>
                <thead>
                    <tr><td colspan="6">{{ invoiceData.title || '' }}</td></tr>
                </thead>
                <tbody>
                    <tr>
                        <td colspan="6" align="left">
                            <div class="td-item">{{`缴款码：${invoiceData.paymentCode || ''}`}}</div>
                            <div class="td-item">
                                <span> {{`执收单位编码：${invoiceData.receivingCode || ''}`}}</span>
                                <span> {{`票据代码：${invoiceData.invoiceCode || ''}`}}</span>
                                <span> {{`校验码：${invoiceData.checkCode || ''}`}}</span>
                            </div>
                            <div class="td-item">
                                <span> {{`执收单位名称：${invoiceData.receivingName || ''}`}}</span>
                                <span> {{`票据号码：${invoiceData.invoiceNumber || ''}`}}</span>
                                <span> {{`填制日期：${invoiceData.billingDate || ''}`}}</span>
                            </div>
                        </td>
                    </tr>
                    <tr><td rowspan="3">付款人</td><td>全称</td><td>{{invoiceData.payerName || ''}}</td><td rowspan="3">收款人</td><td>全称</td><td>{{invoiceData.payeeName || ''}}</td></tr>
                    <tr><td>账号</td><td>{{invoiceData.payerNumber || ''}}</td><td>账号</td><td>{{invoiceData.payeeNumber || ''}}</td></tr>
                    <tr><td>开户银行</td><td>{{invoiceData.payerBank || ''}}</td><td>开户银行</td><td>{{invoiceData.payeeBank || ''}}</td></tr>
                    <tr>
                        <td colspan="4">
                            <div class="td-item" style="justify-content: left;">
                                <span style="margin-right: 50px"> {{`币种：${invoiceData.currencyCode || '人民币'}`}}</span>
                                <span> {{`金额（大写）：${invoiceData.amountTaxCN || ''}`}}</span>
                            </div>
                        </td>
                        <td colspan="2">{{`（小写）：${invoiceData.amountTax || ''}`}}</td>
                    </tr>
                    <tr><td>项目编码</td><td>收入项目名称</td><td>单位</td><td>数量</td><td>收缴标准</td><td>金额</td></tr>
                    <tr v-for="el in invoiceData.invoiceLists" :key="el.commodityNo"><td>{{el.commodityNo || ''}}</td><td>{{el.commodityName || ''}}</td><td>{{el.unit || '元'}}</td><td>{{el.quantity || ''}}</td><td>{{el.standard || ''}}</td><td>{{el.amount || ''}}</td></tr>
                    <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                    <tr><td colspan="3">
                        <div class="td-item">
                            <span> {{`执收单位盖章：${''}`}}</span>
                            <span> {{`经办人盖章：${invoiceData.sealMark || ''}`}}</span>
                        </div>
                    </td><td colspan="3" style="text-align: left;">{{ `备注：${invoiceData.remarks || ''}` }}</td></tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
  
<script>
import { getBaiduNormal, getNetocr, savePayment } from "@/api/common";
import { obsConfig, xiangyunKey } from "@/utils/secret.js";
import { numToCny } from "@/utils/utils.js";

  export default {
    name: 'InvoiceDecoder',
    components: {},
    data() {
        return {
            invoiceData: {},
            filePath: '',
            loading: false,
            recognitionStatus: '', // 'success', 'warning', 'error', ''
            recognitionMessage: '',
            templateDialogVisible: false, // 控制样板弹窗的显示
        };
    },
    computed: {
        showRecognitionStatus() {
            return this.recognitionStatus !== '';
        },
        recognitionStatusType() {
            return this.recognitionStatus;
        },
        recognitionStatusIcon() {
            const iconMap = {
                success: 'el-icon-success',
                warning: 'el-icon-warning',
                error: 'el-icon-error'
            };
            return iconMap[this.recognitionStatus] || '';
        },
        recognitionStatusMessage() {
            return this.recognitionMessage;
        }
    },
    computed: {},
    mounted() {},
    methods: {
        netocr(file) {
            // 重置识别状态
            this.recognitionStatus = '';
            this.recognitionMessage = '';
            
            let formData = new FormData();
            formData.append("file", file);
            formData.append("key", xiangyunKey.key);
            formData.append("secret", xiangyunKey.secret);
            formData.append("typeId", 20090);
            formData.append("format", 'json');
            
            return getNetocr(formData).then(res => {
                const { data } = res;
                if (data && data.length > 0 && data[0]?.invoice) {
                    this.invoiceData = data[0].invoice;
                    this.$message.success('发票识别成功');
                    this.recognitionStatus = 'success';
                    this.recognitionMessage = '发票识别成功，请核对识别结果';
                } else {
                    this.$message.warning('发票识别结果不完整，请确保上传清晰的发票图片');
                    this.invoiceData = {};
                    this.recognitionStatus = 'warning';
                    this.recognitionMessage = '发票识别结果不完整，请确保上传清晰的发票图片或尝试其他格式';
                }
            }).catch(err => {
                console.log("🚀 ~ getNetocr ~ err:", err);
                this.$message.error('发票识别失败，请重试');
                this.invoiceData = {};
                this.recognitionStatus = 'error';
                this.recognitionMessage = '发票识别失败，请检查网络连接或重新上传';
            });
        },
        baiduNormal(base64) {
            const params = {
                // image: base64,
                pdf_file: base64,
                verify_parameter: false,
                probability: false,
                location: false
            }
            getBaiduNormal(params).then(res => {
                console.log("🚀 ~ main ~ res:", res)
            
            }).catch(err => {
                console.log("🚀 ~ main ~ err:", err)
                
            })
        },
        obsFile(file) {
            const domainId = localStorage.getItem("domainId") || "default";
            const now = new Date();
            const y = now.getFullYear();
            const m = now.getMonth()+1<10?'0'+(now.getMonth()+1):now.getMonth()+1;
            const d = now.getDate()<10?'0'+now.getDate():now.getDate();
            const md = m+'-'+d;
			const objectKey=`uploads/${y}/${md}/${domainId}/${now.getTime()}/${file.name}`;
            let _this = this;
			
			// eslint-disable-next-line no-undef
			const obs = new ObsClient({
				access_key_id: obsConfig.ak,
				secret_access_key: obsConfig.sk,
				server : obsConfig.urlserver,
				timeout : 60 * 5,
			});
			obs.putObject({
				Bucket: obsConfig.BucketName,
				Key : objectKey,
				SourceFile: file //获取file文件
			}).then(function(result) {
				if(result.CommonMsg.Status < 300){
                    const httpurl = `https://${obsConfig.BucketName}.${obsConfig.urlserver}/${objectKey}`;
                    _this.filePath = httpurl;
                }
            });
        },
        upload(event) {
            // 获取当前选中的文件
            const file = event.target.files[0];
            if (!file) {
                return;
            }
            
            // 验证文件类型
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
            if (!allowedTypes.includes(file.type)) {
                this.$message.error('只支持PDF、JPG和PNG格式的文件');
                this.$refs.inputRef.value = '';
                return;
            }
            
            // 显示加载状态
            this.loading = true;
            this.$message.info('文件上传中，请稍候...');
            
            // 上传文件并识别
            this.obsFile(file);
            this.netocr(file).finally(() => {
                this.loading = false;
                this.$refs.inputRef.value = '';
            });
        },
        showTemplate() {
            // 显示样板弹窗
            this.templateDialogVisible = true;
        },
        
        handleCloseTemplateDialog(done) {
            // 处理弹窗关闭
            done();
        },
        
        downloadTemplateFile() {
            // 下载样板文件
            const link = document.createElement('a');
            link.href = '/templates/invoice_template.html';
            link.download = '发票样板.html';
            link.onerror = () => {
                this.$message.error('样板文件下载失败，请联系管理员');
            };
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.$message.success('样板文件下载中，请查看您的下载文件夹');
        },
        validateInvoiceData() {
            const requiredFields = {
                invoiceCode: '票据代码',
                checkCode: '校验码',
                receivingCode: '执收单位编码',
                receivingName: '执收单位名称',
                invoiceNumber: '票据号码',
                billingDate: '填制日期',
                payerName: '付款人全称',
                amountTax: '金额'
            };
            
            for (const [field, label] of Object.entries(requiredFields)) {
                if (!this.invoiceData[field]) {
                    this.$message.error(`未能识别${label}，请确保上传文件清晰完整`);
                    return false;
                }
            }
            
            if (!this.invoiceData.invoiceLists || this.invoiceData.invoiceLists.length === 0) {
                this.$message.error('未能识别收入项目信息，请确保上传文件清晰完整');
                return false;
            }
            
            if (!this.invoiceData.paymentCode || this.invoiceData.paymentCode.length < 20) {
                this.$message.error('缴款码长度不足20位，请确保识别无误');
                return false;
            }

            return true;
        },
        onSave() {
            if (!this.filePath) {
                return this.$message.error('请先上传文件');
            }
            
            if (!this.validateInvoiceData()) {
                return;
            }
            const { paymentCode, receivingCode, invoiceCode, checkCode, receivingName, invoiceNumber, billingDate, 
                payerName, payerBank, payerNumber, payeeName, payeeNumber, payeeBank, amountTaxCN, amountTax, invoiceLists, sealMark, remarks
            } = this.invoiceData;
            const params = {
                payment_code: paymentCode,
                collection_unit_code: receivingCode,
                bill_code: invoiceCode,
                verification_code: checkCode,
                collection_unit_name: receivingName,
                bill_number: invoiceNumber,
                fill_date: billingDate,
                payer_name: payerName,
                payer_bank: payerBank,
                payer_account: payerNumber,
                payee_name: payeeName,
                payee_account: payeeNumber,
                payee_bank: payeeBank,
                amount_words: amountTaxCN || numToCny(amountTax),
                amount_figures: this.formateAmout(amountTax),
                project_code: invoiceLists[0]?.commodityNo,
                project_name: invoiceLists[0]?.commodityName,
                number: this.formateAmout(invoiceLists[0]?.quantity),
                fee_standards: this.formateAmout(invoiceLists[0]?.standard),
                sum_price: this.formateAmout(invoiceLists[0]?.amount),
                collection_unit: '',
                operator_name: sealMark,
                remark: remarks,
                file: this.filePath,
            };
            savePayment(params).then(res => {
                if(res.code == 1){
                    this.$message.success(res.msg);
                    setTimeout(()=>{
                        window.open('about:blank','_self').close();
                    }, 3000);
                }else{
                    this.$message.error(res.msg);
                }
            }).catch(err => {
                console.log("🚀 ~ savePayment ~ err:", err)
            })
        },
        formateAmout(num) {
            return num.replace(/,/g, '');
        },
        back() {
            // // 调用全局挂载的方法，关闭当前页
            // this.$store.dispatch("tagsView/delView", this.$route);
            // // 返回上一步路由
            // this.$router.go(-1);
            window.open('about:blank','_self').close();
        }
    }
}
</script>
  
<style lang="scss" scoped>
.container {
    padding: 24px;
    .fileWrap {
        position: relative;
        display: inline-block;
        margin: 0 16px;
        
        input {
            position: absolute;
            right: 0;
            left: 0;
            height: 100%;
            opacity: 0;
            cursor: pointer;
            
            &:disabled {
                cursor: not-allowed;
            }
        }
    }
    
    // 文件类型提示样式
    .file-type-hint {
        font-size: 12px;
        color: #909399;
        margin: 15px 0;
        padding: 8px;
        background-color: #f4f4f5;
        border-radius: 4px;
        
        .supported-types {
            color: #67C23A;
            font-weight: bold;
        }
    }
    
    // 识别状态提示样式
    .recognition-status {
        margin: 15px 0;
        padding: 10px;
        border-radius: 4px;
        font-size: 13px;
        display: flex;
        align-items: center;
        
        i {
            margin-right: 8px;
            font-size: 16px;
        }
        
        &.success {
            background-color: #f0f9eb;
            color: #67C23A;
            border: 1px solid #e1f3d8;
        }
        
        &.warning {
            background-color: #fdf6ec;
            color: #e6a23c;
            border: 1px solid #faecd8;
        }
        
        &.error {
            background-color: #fef0f0;
            color: #f56c6c;
            border: 1px solid #fde2e2;
        }
    }
    
    .tableWrap {
        margin-top: 24px;
        table {
            border-collapse: collapse;
            margin: auto;
            td {
                padding: 12px;
                border: 1px solid #000;
                .td-item {
                    display: flex;
                    justify-content: space-between;
                    padding: 4px 0;
                    span {
                        display: block;
                    }
                }
            }
        }
    }

    // 样板弹窗样式
    .template-container {
        padding: 20px;
        background-color: #fff;

        .template-header {
            text-align: center;
            margin-bottom: 20px;
            h2 {
                font-size: 24px;
                color: #303133;
                margin: 0;
            }
        }

        .template-content {
            .template-info {
                margin-bottom: 20px;
                p {
                    margin: 8px 0;
                    color: #606266;
                    strong {
                        color: #303133;
                    }
                }
                .template-row {
                    display: flex;
                    justify-content: space-between;
                    margin: 8px 0;
                }
            }

            .template-table {
                table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 20px;
                    
                    td {
                        padding: 12px;
                        border: 1px solid #DCDFE6;
                        color: #606266;
                        
                        strong {
                            color: #303133;
                        }
                    }
                }
            }
        }
    }

    // 弹窗自定义样式
    ::deep(.el-dialog__body) {
        padding: 0;
    }
}
</style>
  